<template>
  <a-drawer width="60%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('云种植公告.公告标题')" prop="title">
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('通用.输入.请输入') + $t('云种植公告.公告标题')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植公告.封面图')" prop="coverImage">
        <OssUploadSingle v-model="form.coverImage" type="img" :maxSize="200"></OssUploadSingle>
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植公告.简介')" prop="summary">
        <a-textarea v-model="form.summary" :maxLength="500" :rows="3" :placeholder="$t('通用.输入.请输入') + $t('云种植公告.简介')" allow-clear />
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植公告.公告时间')" prop="noticeTime">
        <a-date-picker
          v-model="form.noticeTime"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          :placeholder="$t('通用.输入.请选择') + $t('云种植公告.公告时间')"
          style="width: 100%"
        />
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植公告.内容')" prop="content">
        <editor v-model="form.content" />
      </a-form-model-item>

<!--      <a-form-model-item :label="$t('云种植公告.状态')" prop="status">-->
<!--        <a-radio-group v-model="form.status">-->
<!--          <a-radio v-for="(item, index) in customDict.NoticeStatusEnum" :key="index" :value="item.type">-->
<!--            {{ item.name }}-->
<!--          </a-radio>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->

      <a-form-model-item :label="$t('云种植公告.排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="9999" style="width: 200px" />
        <span style="margin-left: 10px; color: #999">{{ $t('云种植公告.排序提示') }}</span>
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植公告.备注')" prop="remark">
        <a-textarea v-model="form.remark" :rows="2" :placeholder="$t('通用.输入.请输入') + $t('云种植公告.备注')" allow-clear />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
          <a-button @click="cancel">{{ $t('通用.按钮.取消') }}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getNotice, addNotice, updateNotice } from '@/api/cloudplant/notice'
import OssUploadSingle from '@/components/OssUploadSingle'
import Editor from '@/components/Editor'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateForm',
  components: { OssUploadSingle, Editor },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      formTitle: '',
      open: false,
      formType: 1,
      form: {
        id: null,
        title: null,
        coverImage: null,
        summary: null,
        noticeTime: null,
        content: null,
        status: 1,
        sort: 0,
        remark: null
      },
      rules: {
        title: [{ required: true, message: this.$t('云种植公告.公告标题') + this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        coverImage: null,
        summary: null,
        noticeTime: null,
        content: null,
        status: 1,
        sort: 0,
        remark: null
      }
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      getNotice({ id: row.id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            updateNotice(this.form)
              .then(() => {
                this.$message.success(this.$t('通用.文本.修改成功'))
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addNotice(this.form)
              .then(() => {
                this.$message.success(this.$t('通用.文本.新增成功'))
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        }
      })
    }
  }
}
</script>
<style scoped>
/* 覆盖富文本编辑器默认高度 */
::v-deep .adaptive {
  height: auto;
}
::v-deep .editor .w-e-text-container {
  height: 500px !important;
}
</style>
